exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-hd[data-v-b2a0f8f0]{font-size:3rem}", ""]);

// exports
